export default "__VITE_ASSET__un1X7o9q__"